import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { useStoreInitializer } from "@/hooks/useStoreInitializer";
import { AppRouter } from "@/router/AppRouter";
import { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Spinner } from "./components/ui/spinner";

function App() {
  useStoreInitializer();

  return (
    <ThemeProvider defaultTheme="light" storageKey="crolytics-theme">
      <Router>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-screen-mobile">
              <Spinner variant="circle" />
            </div>
          }
        >
          <AppRouter />
        </Suspense>
      </Router>
      <Toaster theme="light" />
    </ThemeProvider>
  );
}

export default App;
